import { NAV_TYPE_SIDE , SIDE_NAV_DARK } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

export const APP_NAME = 'SPOCTO360';
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';

export const THEME_CONFIG = {
	navCollapsed: true,
	sideNavTheme: SIDE_NAV_DARK,
	locale: 'en',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#3e82f7',
	headerNavColor: '#ffffff',
	mobileNav: false,
	modalStatus: false
};
